import DynamicComponent from ".."

export default function HeadingTextDividerSection({ blok }) {
  const backgroundColor = blok.background_color

  return (
    <section className={`px-5 py-12 bg-${backgroundColor}`}>
      <div className="max-w-screen-xl mx-auto">
        <div>
          {blok.content.map((blok) => {
            blok.background_color = backgroundColor
            return <DynamicComponent blok={blok} key={blok._uid} />
          })}
        </div>
      </div>
    </section>
  )
}
